/* eslint-disable no-unused-vars */

import React from 'react'
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import { CommonPageData } from '../../styles/common.style';

const ComingSoon = () => {
  return (
    <div className="coming-soon-bg">
      <Header />
      <CommonPageData>
        <div className="coming-soon-container">
          <h1 className="coming-heading">COMING SOON</h1>
          <p className="coming-subtitle">
            From automation of people processes to creating<br />
            an engaged and driven culture.
          </p>
          <form className="notify-form" onSubmit={e => e.preventDefault()}>
            <input
              type="email"
              className="notify-input"
              placeholder="Please enter your email address"
              required
            />
            <button type="submit" className="notify-btn">Notify Me</button>
          </form>
        </div>
      </CommonPageData>
      
    </div>
  )
}

export default ComingSoon